export const VRXIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="21"
    fill="none"
    viewBox="0 0 26 21"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.953 2.576 19.182.043H16.25l-1.207 2.533zM9.246 13.2 2.845 0H0l8.556 17.623h2.823z"
      clipRule="evenodd"
    ></path>
    <path
      fill="currentColor"
      d="m23.644 19.18-1.465-2.044 1.487-1.69c.28-.355.603-.444.948-.444v-.377H22.48v.377c.367.045.56.134.56.311 0 .112-.064.223-.172.4l-.323.356-.647.733-2.327-3.244c.905-.2 2.069-.934 2.069-2.334s-1.078-2.4-3.125-2.4h-3.513v.378c.862.111 1.013.178 1.013.889v6.245c0 .689-.151.778-1.013.889v.378h3.47v-.378c-.862-.111-1.013-.178-1.013-.89v-2.533h.733l2.801 4.023-1.594 1.8-.173.178c-.237.289-.603.422-.948.444v.378h2.263v-.378c-.41-.022-.668-.133-.668-.333 0-.09.043-.222.15-.356l1.229-1.378.905 1.29c.366.533.647.91 1.013 1.155h2.026v-.378c-.647-.022-1.013-.267-1.573-1.044zm-5.452-5.867h-.712V9.27h.668c1.38 0 2.026.844 2.026 1.955 0 1.312-.625 2.09-1.982 2.09"
    ></path>
  </svg>
);
